module.exports = require("./ne");